import { Field } from '@scandipwa/scandipwa/src/util/Query';
import {
    MenuQuery as SourceMenuQuery,
} from 'SourceQuery/Menu.query';

export class MenuQuery extends SourceMenuQuery {
    getQuery({ identifier }) {
        return new Field('scandiwebMenu')
            .addArgument('identifier', 'String!', identifier)
            .addFieldList(this._getMenuFields())
            .setAlias('menu');
    }

    _getMenuFields() {
        return [
            // 'menu_id',
            // 'is_active',
            // 'css_class',
            this._getMenuItemsField()
        ];
    }

    _getMenuItemsField() {
        return new Field('items')
            .addFieldList(this._getMenuItemFields());
    }

    _getMenuItemFields() {
        return [
            'category_id',
            'item_id',
            'parent_id',
            'position',
            'title',
            'url',
            'icon',
            // 'url_type',
            // 'is_active',
            // 'item_class',
            // 'cms_page_identifier',
            'label_no_url',
            'labelwithimage',
            'label_no_url',
            'labelwithimage'
        ];
    }
}

export default new MenuQuery();
